import { useCallback } from 'react';

import { UPGRADE_DIALOG_ACTIONS_ORIGIN } from 'src/data/common';
import { FEATURE_LIMITS } from 'src/data/featureLimits';

import { useUpgradePopup } from './useUpgradePopup';

/**
 * Ready-made "Get score" click handler: opens the upgrade popup for the
 * performance-predictions limit with the editor Get-score origin. Shared by every
 * locked-score surface so the popup wiring lives in one place.
 */
export const useGetScoreUpgradeClick = () => {
  const openUpgradePopup = useUpgradePopup({
    actionsOrigin: UPGRADE_DIALOG_ACTIONS_ORIGIN.editorGetScoreButton,
  });

  return useCallback(() => {
    openUpgradePopup(FEATURE_LIMITS.performancePredictions);
  }, [openUpgradePopup]);
};
